import React from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"
import { tariffTypeKey } from "Pages/DsRepricing/Page/@services/adapters"
import { PREPAID_OPTIONS } from "Pages/DsRepricing/Setup/@services/axes"
import { inputSx } from "Pages/DsRepricing/Setup/@components/formStyles"

// The tariff-type axis of the face scope (CU-869fe6mf4). A three-state
// Select and not the multi + exclusion switch its six siblings use: the
// axis has two values, so "exclude Prepaid" and "Non prepaid" are the
// same rule twice, and a selector that lets the operator write one rule
// three ways produces strategies that look different and are not (UX
// decision 5). The same control the face itself uses in Setup → Rate
// cards, with the same list — `PREPAID_OPTIONS`, never
// `AppPrepaidAutocomplete`, whose endpoint spells "Non Prepaid" with a
// capital P and offers a partial value a face cannot have.
export default function DsRepricingFilterTariffType() {
	const { dataInfo, setDataInfo } = useDsRepricingDataInfo(dsRepricingDrawerData.peek().filterTariffTypes ?? [])
	const key = tariffTypeKey(dataInfo.value)

	return (
		<FormControl size="small" fullWidth sx={inputSx}>
			<InputLabel id="ds-repricing-tariff-type-label" shrink>Tariff type</InputLabel>
			<Select labelId="ds-repricing-tariff-type-label"
			        label="Tariff type" notched displayEmpty
			        value={key}
			        onChange={e => setDataInfo(e.target.value ? [e.target.value] : [], 'filterTariffTypes')}>
				<MenuItem value=""><em>All tariff types</em></MenuItem>
				{PREPAID_OPTIONS.map(o => (
					<MenuItem key={o.code} value={o.code}>{o.name}</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
